module.exports = __webpack_public_path__ + "static/img/sspg_02.ad1ed49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_02.jpg
// module id = yDt8
// module chunks = 1